__turbopack_context__.v({
  "description": "Services-module-scss-module__E8fXka__description",
  "grid": "Services-module-scss-module__E8fXka__grid",
  "headerWrapper": "Services-module-scss-module__E8fXka__headerWrapper",
  "heading": "Services-module-scss-module__E8fXka__heading",
  "icon": "Services-module-scss-module__E8fXka__icon",
  "iconWrapper": "Services-module-scss-module__E8fXka__iconWrapper",
  "label": "Services-module-scss-module__E8fXka__label",
  "section": "Services-module-scss-module__E8fXka__section",
  "service": "Services-module-scss-module__E8fXka__service",
  "services": "Services-module-scss-module__E8fXka__services",
});
